(() => {
  const ROOT_SELECTOR = 'form.bss-b2b-quick-order-list, form[is="quick-order-list"]';

  function parseMoney(text) {
    if (!text) return 0;
    const raw = String(text).replace(/[^\d,.\-]/g, '').trim();
    if (!raw) return 0;
    if (raw.includes(',')) {
      return parseFloat(raw.replace(/\./g, '').replace(',', '.')) || 0;
    }
    const parts = raw.split('.');
    if (parts.length > 2) {
      return parseFloat(parts.slice(0, -1).join('') + '.' + parts[parts.length - 1]) || 0;
    }
    return parseFloat(raw) || 0;
  }

  function formatMoney(amount) {
    const cents = Math.round(amount * 100);
    if (window.FoxTheme?.Currency?.formatMoney) {
      return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings?.moneyFormat);
    }
    return amount.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  function netAmount(el) {
    if (!el) return 0;
    const net = el.querySelector('.bss-b2b-price-no-vat');
    if (!net) return 0;
    return parseMoney(net.textContent);
  }

  let updating = false;

  function setNetAmount(el, amount) {
    if (!el) return;
    const formatted = formatMoney(amount);
    let net = el.querySelector('.bss-b2b-price-no-vat');
    if (!net) {
      net = document.createElement('span');
      net.className = 'bss-b2b-price-no-vat';
    }
    if (net.textContent.trim() !== formatted.trim()) {
      net.textContent = formatted;
    }
    if (el.childNodes.length !== 1 || el.firstElementChild !== net) {
      el.replaceChildren(net);
    }
  }

  function updateForm(form) {
    if (!form || !form.querySelector('.bss-b2b-price-no-vat')) return;

    updating = true;
    let productTotal = 0;
    form.querySelectorAll('tr.variant-item').forEach((row) => {
      const qty = parseInt(row.querySelector('.quantity__input')?.value || '0', 10) || 0;
      const unitEl = row.querySelector('price-per-item[bss-b2b-variant-price], [bss-b2b-variant-unit-price]');
      const unit = netAmount(unitEl);
      if (!unit) return;

      const lineTotal = unit * qty;
      productTotal += lineTotal;

      row.querySelectorAll('[bss-b2b-order-list-total-line]').forEach((lineEl) => {
        setNetAmount(lineEl, lineTotal);
      });
    });

    const productTotalEl = form.querySelector('[bss-b2b-order-list-total]');
    if (productTotalEl) {
      setNetAmount(productTotalEl, productTotal);
    }
    updating = false;
  }

  function updateAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(updateForm);
  }

  let scheduled = false;
  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      updateAll();
    });
  }

  function bind(form) {
    if (!form || form.dataset.bssNetTotalsBound === 'true') return;
    form.dataset.bssNetTotalsBound = 'true';
    form.addEventListener('change', scheduleUpdate);
    form.addEventListener('input', scheduleUpdate);
  }

  function init() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(bind);
    scheduleUpdate();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('cart:updated', () => setTimeout(init, 50));
  document.addEventListener('shopify:section:load', init);

  const observer = new MutationObserver((mutations) => {
    if (updating) return;
    const relevant = mutations.some((mutation) => {
      if (mutation.target?.closest?.(ROOT_SELECTOR)) return true;
      return Array.from(mutation.addedNodes || []).some(
        (node) =>
          node.nodeType === 1 &&
          (node.matches?.(ROOT_SELECTOR) || node.querySelector?.(ROOT_SELECTOR) || node.classList?.contains('bss-b2b-price-no-vat'))
      );
    });
    if (relevant) init();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
